import { render, staticRenderFns } from "./JobsTable.vue?vue&type=template&id=4a91c07c&"
import script from "./JobsTable.vue?vue&type=script&lang=js&"
export * from "./JobsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports